import { useNavigate } from 'react-router-dom';
import BackButton from './BackButton';
import './VideoPage.css';
import LaunchBayVideo from './video/launch-rocket.mp4';
import ReactPlayer from 'react-player';
import { AudioPlayer } from 'react-audio-play';
import LaunchBayAudio from './music/ticket-to-the-moon.wav';

const VideoPage = () => {
  const navigate = useNavigate();

  return (
    <div className="video-page">
      <ReactPlayer url={LaunchBayVideo} className="video" playing={true} playsinline={true} />
      <p className="video-text">Escape to the stars...</p>
      <AudioPlayer src={LaunchBayAudio} autoPlay />
      <BackButton onClick={() => navigate('/fork')} />
    </div>
    
  );
};

export default VideoPage;